import React, { useState, useEffect } from 'react';
import BottomModal from '../ButtonGroup/BottomModal';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { IUserLuckyOne } from '../../store/LuckyStore';
import { style } from '../../utils/image';
import './LuckResultModal.scss';

const Index = (props: {
  visible: boolean;
  onClose: () => void;
  rootStore?: RootStore;
  luckId: string | number;
}) => {
  const { visible, onClose, rootStore, luckId } = props;

  const [page, setPage] = useState(1);
  const [list, setList] = useState([] as IUserLuckyOne[]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const fetchList = () => {
    let { luckyStore } = rootStore!;
    setLoading(true);
    luckyStore.getLuckResult(luckId, page).then((res: any) => {
      setLoading(false);
      if (res && res.data) {
        let { items, total } = res.data;
        let newList = list.concat(items);
        setList(newList);
        setTotal(total);
      }
    });
  };

  useEffect(() => {
    if (page) {
      fetchList();
    }
  }, [page]);

  return (
    <BottomModal
      title={'中奖名单'}
      show={visible}
      onHide={onClose}
      child={
        <div className="luck-result-modal">
          <div className="wrapper">
            <div className="table">
              <div className="row title">
                <div className="column">昵称</div>
                <div className="column">中奖礼品</div>
              </div>
              {list.map((it: any) => {
                let { userdetail, goodsdetail } = it;
                return (
                  <div className="row record" key={it.id}>
                    <div className="column">
                      <img src={userdetail.photo} />
                      <span>{userdetail.nickname}</span>
                    </div>
                    <div className="column">{goodsdetail.desc}</div>
                  </div>
                );
              })}
              {list.length < total ? (
                <div
                  className="footer"
                  onClick={() => (loading ? null : setPage(page + 1))}
                >
                  <a>{loading ? '加载中' : '点击加载更多'}</a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      }
    />
  );
};

export default inject('rootStore')(observer(Index));
